import { observer } from 'mobx-react';
import * as React from 'react';
import { withRouter } from 'react-router';
import { RouteComponentProps } from 'react-router-dom';
import { Login } from '..';
import { OAuthLoginViewModel, UserSessionContext } from '../../../../viewmodels/AppViewModels';

interface IProps extends RouteComponentProps<any> {
	className?: string;
	userSession?: UserSessionContext;
}

interface IState {
	loginVM?: OAuthLoginViewModel;
}

export class _OAuthLogin extends React.Component<IProps, IState> {
	constructor(props: IProps) {
		super(props);
		const loginVM = new OAuthLoginViewModel(this.props.userSession, this.usernamePasswordValidCallback);
		loginVM.setQueryString(this.props.location.search);

		this.state = {
			loginVM,
		};
	}

	public render() {
		return (
			<Login
				{...this.props}
				autoRedirectIfAuthenticated={false}
				loginMode='standard'
				showRememberMe={false}
				showSignupButton={false}
				loginVM={this.state.loginVM}
			/>
		);
	}

	private usernamePasswordValidCallback = (redirectUrl: string) => {
		window.location.href = redirectUrl;
	};
}

const OAuthLoginObserver = observer(_OAuthLogin);

// Return the HOC as a top-level object in order to preserve HMR
export const OAuthLogin = withRouter(OAuthLoginObserver);
